import { atom } from 'jotai';

export interface MultiMakeModelFilterState {
  [key: number]: boolean;
}

const MultiMakeModelFilterAtom = atom<MultiMakeModelFilterState>({
  0: true,
  1: false,
  2: false,
});

export default MultiMakeModelFilterAtom;
